import * as React from 'react';

const QuotesPage = () => {
  return (
    <div data-testid="QAQuotesPageTempText">This is the quotes page!</div>
  );
};

export default QuotesPage;